module.exports = "https://static.wmbcdn.com/uniweb/images/ae9bf79412a11c61f0a865ac13d2bc2d.svg";